module.exports = __webpack_public_path__ + "img/laravel.df9eff39.svg";